import { render, staticRenderFns } from "./SupportDetails.vue?vue&type=template&id=38c720cc&"
import script from "./SupportDetails.vue?vue&type=script&lang=js&"
export * from "./SupportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports